
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tooltipText',
  standalone: false
})
export class TooltipTextPipe implements PipeTransform {
  transform(
    colName: string,
    row: { description?: string; exception?: string },
    descriptionCol: string
  ): string {
    const sourceText = colName === descriptionCol ? row.description ?? '' : row.exception ?? '';

    return sourceText.length > 1000 ? sourceText.slice(0, 1000) + '…' : sourceText;
  }
}
